import { useClientTranslation } from '@lib/i18n/client';
import { Alert } from '@tuic/web-compositions/core/Alert';

import type { FC, PropsWithChildren } from 'react';

type Props = PropsWithChildren;

export const CredentialsWarning: FC<Props> = ({ children }) => {
  const { t } = useClientTranslation();

  return (
    <div className="mx-6 mt-6 space-y-8">
      <Alert
        headline={t('Mit Produktions-Zugangsdaten angemeldet')}
        mode="attention"
      >
        <div className="space-y-4">
          <p>
            {t(
              'Die Internet-Card ist aktuell bei GetSlash mit Produktions-Zugangsdaten angemeldet.',
            )}
          </p>
          <ul className="ml-4 list-disc space-y-1">
            <li>
              {t(
                'Im Bordnetzwerk getätigte Tarif-Buchungen werden dem Bordkonto einer echten Person angelastet.',
              )}
            </li>
            <li>
              {t(
                'Das Pausieren und Fortsetzen eines Tarifs innerhalb des Bordnetzwerks, wirkt sich auf tatsächlich gebuchte Tarife von echten Personen aus.',
              )}
            </li>
          </ul>
        </div>
      </Alert>

      {children}
    </div>
  );
};
